module.exports = __webpack_public_path__ + "img/08.c8014b46.png";